module.exports = __webpack_public_path__ + "img/undraw_team_goals_hrii.d3032592.png";